import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { X, Check } from 'lucide-react';
import { CropData } from '../../types/colonia';

type Area = { x: number; y: number; width: number; height: number };

interface PhotoCropperProps {
  imageUrl: string;
  aspect: number;
  onSave: (crop: CropData) => void;
  onCancel: () => void;
}

const PhotoCropper: React.FC<PhotoCropperProps> = ({ imageUrl, aspect, onSave, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

  const onCropComplete = useCallback((_croppedArea: Area, croppedAreaPixels: Area) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = () => {
    if (croppedAreaPixels) {
      onSave(croppedAreaPixels);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-black/90">
      <div className="relative flex-1">
        {/* @ts-ignore - Tipo incompatível entre react-easy-crop (React 18) e React 19 */}
        <Cropper
          image={imageUrl}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </div>
      <div className="bg-white p-4 flex items-center justify-between gap-4 safe-bottom">
        <div className="flex-1 flex items-center gap-2 max-w-sm">
          <span className="text-sm font-medium text-gray-600">Zoom</span>
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={(e) => setZoom(Number(e.target.value))}
            className="flex-1 w-full h-2 bg-gray-200 rounded-lg appearance-none accent-blue-600 cursor-pointer"
          />
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onCancel}
            className="flex items-center gap-2 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
          >
            <X size={18} />
            <span className="hidden sm:inline">Cancelar</span>
          </button>
          <button
            onClick={handleSave}
            className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 font-medium"
          >
            <Check size={18} />
            <span className="hidden sm:inline">Salvar</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotoCropper;
